import { mutate } from 'swr';

export const mutateKeyData = ({ key, revalidate, cb }) =>
    mutate(
        key,
        (currentData) => {
            if (!currentData) {
                return;
            }

            return cb(currentData, key);
        },
        { revalidate }
    );

export const mutateRequestKeysData = ({ requestKeysToMutate, revalidate = true, cb }) => {
    if (requestKeysToMutate) {
        requestKeysToMutate?.map((key) => {
            mutateKeyData({ key, revalidate, cb });
        });
    }
};

// does not clear the cached data, but starts a background request
export const revalidateAllCachedRequest = ({ requestKeysToMutate }) => {
    requestKeysToMutate?.map((key) => {
        mutate(key);
    });
};

// Clears the cache and makes new requests
export const mutateAllCachedRequest = ({ requestKeysToMutate }) => {
    requestKeysToMutate?.map((key) => {
        mutate(key, null, true);
    });
};

export const mutateListDataAfterRenamingItem = ({ requestKeysToMutate, id, updatedName }) => {
    mutateRequestKeysData({
        requestKeysToMutate,
        revalidate: false,
        cb: (currentData) => {
            const updatedResults = currentData.results.map((item) =>
                item.id === id ? { ...item, name: updatedName } : item
            );

            return { ...currentData, results: updatedResults };
        },
    });
};

export const mutateListDataAfterUpdatingItemField = ({
    requestKeysToMutate,
    id,
    fieldName,
    fieldValue,
}) => {
    mutateRequestKeysData({
        requestKeysToMutate,
        revalidate: false,
        cb: (currentData) => {
            const updatedResults = currentData.results.map((item) =>
                item.id === id ? { ...item, [fieldName]: fieldValue } : item
            );

            return { ...currentData, results: updatedResults };
        },
    });
};

export const mutateListDataAfterUpdatingItem = ({ requestKeysToMutate, id, updatedPart = {} }) => {
    mutateRequestKeysData({
        requestKeysToMutate,
        revalidate: false,
        cb: (currentData) => {
            const updatedResults = currentData.results.map((item) =>
                item.id === id ? { ...item, ...updatedPart } : item
            );

            return { ...currentData, results: updatedResults };
        },
    });
};

export const mutateListDataAfterUpdatingItemWithCb = ({ requestKeysToMutate, id, cb }) => {
    mutateRequestKeysData({
        requestKeysToMutate,
        revalidate: false,
        cb: (currentData) => {
            const updatedResults = currentData.results.map((item) =>
                item.id === id ? cb(item) : item
            );

            return { ...currentData, results: updatedResults };
        },
    });
};

export const mutateDataAfterDeletingItem = ({ requestKeysToMutate, id }) => {
    mutateRequestKeysData({
        requestKeysToMutate,
        revalidate: true,
        cb: (currentData, key) => {
            const isKeyWithSearch = key.includes('search=' || 'query=');
            const isDeletedItemMissedInResultsWithSearchQuery =
                isKeyWithSearch && !currentData.results.find((item) => item.id === id);
            if (isDeletedItemMissedInResultsWithSearchQuery) {
                return currentData;
            }

            const results = currentData.results.filter((item) => item.id !== id);

            let count = currentData.count;
            if (results.length < currentData.results.length) {
                count = Math.max(currentData.count - 1, 0);
            }

            return { ...currentData, results, count };
        },
    });
};

export const mutateListDataAfterItemStatusChanging = ({ requestKeysToMutate, id, status }) => {
    mutateRequestKeysData({
        requestKeysToMutate,
        revalidate: false,
        cb: (currentData) => {
            const updatedResults = currentData.results.map((item) =>
                item.id === id ? { ...item, status } : item
            );

            return { ...currentData, results: updatedResults };
        },
    });
};

export const mutateListDataAfterCreatingItem = async ({ requestKeysToMutate, currentKey }) => {
    if (currentKey) {
        await mutate(currentKey);
    }

    if (!requestKeysToMutate || !requestKeysToMutate?.length) return;

    const restKeys = requestKeysToMutate.filter((key) => key !== currentKey);
    mutateAllCachedRequest({ requestKeysToMutate: restKeys });
};
